var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "submit_btn"
  }, [_c('van-button', {
    class: `btn ${this.bgClass}`,
    attrs: {
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('submit');
      }
    }
  }, [_vm._v(_vm._s(_vm.text))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };